import { inject, Injectable } from '@angular/core';
import { computed } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { CreditCheckData } from '../../../../../../models/order/workflow/credit-check.model';
import { FlowTypes } from '../../../../../../models/order/order.model';
import { OrderApiResponseStateService } from '../../order-api-response/order-api-response-state.service';



@Injectable({ providedIn: 'root' })
export class CreditCheckStateService extends BaseWorkflowStateService<CreditCheckData> {
    private orderApiResponseState: OrderApiResponseStateService = inject(OrderApiResponseStateService);
    private _apiData = this.orderApiResponseState.apiData;
    protected override stateKey: string = 'creditCheck';

    apiData = computed(() => this._apiData());

    orderState = computed(() => this.orderStateService.order() || null);

    internetFlowData = computed(() => this.orderStateService.order()?.internetFlow || null);
    videoFlowData = computed(() => this.orderStateService.order()?.videoFlow || null);
    wirelessFlowData = computed(() => this.orderStateService.order()?.wirelessFlow || null);

    internetProvider = computed(() => this.internetFlowData()?.provider || null);
    videoProvider = computed(() => this.videoFlowData()?.provider || null);

    currentFlowType = computed(() => this.orderStateService.currentFlowType());

    serviceAvailabilityData = this.orderApiResponseState.serviceAvailabilityData;
    customer = this.orderApiResponseState.customer;

    setIdAuthenticationComplete(value: boolean) {
        switch (this.orderStateService.currentFlowType()) {
            case FlowTypes.INTERNET:
                this.updateData({
                    internetIdAuthenticationComplete: value
                });
                break;
            case FlowTypes.WIRELESS:
                this.updateData({
                    wirelessIdAuthenticationComplete: value
                });
                break;
            case FlowTypes.VIDEO:
                this.updateData({
                    videoIdAuthenticationComplete: value
                });
                break;
        }
    }

    public setCreditSubmitted(value: boolean) {
        switch (this.orderStateService.currentFlowType()) {
            case FlowTypes.INTERNET:
                this.updateData({
                    internetCreditSubmitted: value
                });
                break;
            case FlowTypes.WIRELESS:
                this.updateData({
                    wirelessCreditSubmitted: value
                });
                break;
            case FlowTypes.VIDEO:
                this.updateData({
                    videoCreditSubmitted: value
                });
                break;
        }
    }
}